import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  // Hide on the Book page itself
  const isBookPage = location.pathname === '/book';

  useEffect(() => {
    if (isBookPage) { setVisible(false); return; }

    const onScroll = () => {
      const scrolled = window.scrollY > window.innerHeight * 0.6;
      setVisible(scrolled);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isBookPage]);

  // Ripple effect on btn click
  const handleClick = (e) => {
    const btn = e.currentTarget;
    const ripple = document.createElement('span');
    ripple.className = 'btn-ripple';
    const rect = btn.getBoundingClientRect();
    ripple.style.left = `${e.clientX - rect.left}px`;
    ripple.style.top  = `${e.clientY - rect.top}px`;
    btn.appendChild(ripple);
    ripple.addEventListener('animationend', () => ripple.remove());
  };

  if (isBookPage) return null;

  return (
    <div className={`sticky-cta${visible ? ' visible' : ''}`} aria-hidden={!visible}>
      <p className="sticky-cta-text">
        <strong>Limited spots left</strong> — Book your free consultation today
      </p>
      <Link
        to="/book"
        className="btn btn-primary btn-sm"
        onClick={handleClick}
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        Book Now
      </Link>
    </div>
  );
}
